import { render, staticRenderFns } from "./CollisionResolveDialog.vue?vue&type=template&id=7fd0186f&scoped=true&"
import script from "./CollisionResolveDialog.vue?vue&type=script&lang=js&"
export * from "./CollisionResolveDialog.vue?vue&type=script&lang=js&"
import style0 from "./CollisionResolveDialog.vue?vue&type=style&index=0&id=7fd0186f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd0186f",
  null
  
)

export default component.exports